import { useQueryClient, VueQueryPlugin } from '@tanstack/vue-query'

const EIGHT_HOURS = 1000 * 60 * 60 * 8
export default defineNuxtPlugin((nuxtApp) => {
  const { vueApp } = nuxtApp
  vueApp.use(VueQueryPlugin)
  const queryClient = useQueryClient()
  queryClient.setDefaultOptions({
    queries: { staleTime: EIGHT_HOURS },
  })
})
